export var getFieldFromString = function getFieldFromString(value) {
  var res;
  if (value === 'true') {
    res = true;
  } else if (value === 'false') {
    res = false;
  } else if (value === 'null') {
    return null;
  } else if (value === 'undefined') {
    res = undefined;
    // eslint-disable-next-line no-useless-escape
  } else if (!/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(value.replace(/"(\\.|[^"\\])*"/g, ''))) {
    res = JSON.parse(value);
  } else if (/^-?\d+\.?\d*$/.test(value)) {
    res = Number(value);
  } else {
    res = value;
  }
  return res;
};